export enum ChatFilterType {
  All = 'all',
  Live = 'web',
  Zalo = 'zalo',
  Facebook = 'facebook',
  Internal = 'internal',
}

export function isValidFilter(type: string) {
  const keys = Object.keys(ChatFilterType);
  return keys.some(item => ChatFilterType[item] === type);
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/chat/side-bar/sidebar.const.ts